export const nswGrey = {
  '50': 'rgb(250, 250, 250)',
  '100': 'rgb(245, 245, 245)',
  '150': 'rgb(240, 240, 240)',
  '200': 'rgb(235, 235, 235)',
  '250': 'rgb(227, 229, 230)',
  '300': 'rgb(220, 223, 224)',
  '350': 'rgb(212, 217, 219)',
  '400': 'rgb(205, 211, 214)',
  '450': 'rgb(170, 176, 180)',
  '500': 'rgb(136, 143, 146)',
  '550': 'rgb(104, 111, 114)',
  '600': 'rgb(73, 80, 84)',
  '650': 'rgb(63, 69, 73)',
  '700': 'rgb(53, 59, 63)',
  '750': 'rgb(43, 49, 53)',
  '800': 'rgb(34, 39, 43)',
  '850': 'rgb(24, 28, 31)',
  '900': 'rgb(14, 17, 19)',
  '950': 'rgb(5, 7, 9)',
}
export const nswGreen = {
  '50': 'rgb(245, 255, 246)',
  '100': 'rgb(236, 253, 238)',
  '150': 'rgb(228, 252, 231)',
  '200': 'rgb(219, 250, 223)',
  '250': 'rgb(207, 247, 212)',
  '300': 'rgb(194, 244, 201)',
  '350': 'rgb(181, 240, 190)',
  '400': 'rgb(168, 237, 179)',
  '450': 'rgb(138, 220, 152)',
  '500': 'rgb(106, 204, 125)',
  '550': 'rgb(69, 187, 98)',
  '600': 'rgb(0, 170, 69)',
  '650': 'rgb(7, 142, 50)',
  '700': 'rgb(7, 115, 32)',
  '750': 'rgb(3, 89, 15)',
  '800': 'rgb(0, 64, 0)',
  '850': 'rgb(0, 48, 0)',
  '900': 'rgb(0, 32, 0)',
  '950': 'rgb(0, 17, 0)',
}
export const nswTeal = {
  '50': 'rgb(242, 251, 250)',
  '100': 'rgb(231, 247, 245)',
  '150': 'rgb(220, 242, 239)',
  '200': 'rgb(209, 238, 234)',
  '250': 'rgb(193, 234, 231)',
  '300': 'rgb(175, 229, 229)',
  '350': 'rgb(158, 224, 229)',
  '400': 'rgb(140, 219, 229)',
  '450': 'rgb(117, 196, 207)',
  '500': 'rgb(94, 172, 185)',
  '550': 'rgb(70, 150, 163)',
  '600': 'rgb(46, 128, 142)',
  '650': 'rgb(37, 111, 123)',
  '700': 'rgb(28, 95, 105)',
  '750': 'rgb(20, 78, 88)',
  '800': 'rgb(11, 63, 71)',
  '850': 'rgb(4, 47, 53)',
  '900': 'rgb(1, 31, 36)',
  '950': 'rgb(0, 17, 20)',
}
export const nswBlue = {
  '50': 'rgb(240, 251, 255)',
  '100': 'rgb(228, 246, 255)',
  '150': 'rgb(215, 242, 254)',
  '200': 'rgb(203, 237, 253)',
  '250': 'rgb(188, 234, 254)',
  '300': 'rgb(173, 231, 255)',
  '350': 'rgb(157, 227, 255)',
  '400': 'rgb(140, 224, 255)',
  '450': 'rgb(90, 201, 255)',
  '500': 'rgb(38, 174, 255)',
  '550': 'rgb(0, 143, 255)',
  '600': 'rgb(20, 108, 253)',
  '650': 'rgb(12, 90, 212)',
  '700': 'rgb(5, 72, 173)',
  '750': 'rgb(2, 54, 136)',
  '800': 'rgb(0, 38, 100)',
  '850': 'rgb(0, 26, 77)',
  '900': 'rgb(0, 16, 55)',
  '950': 'rgb(0, 6, 34)',
}
export const nswPurple = {
  '50': 'rgb(249, 247, 255)',
  '100': 'rgb(242, 240, 255)',
  '150': 'rgb(236, 232, 254)',
  '200': 'rgb(230, 225, 253)',
  '250': 'rgb(224, 217, 254)',
  '300': 'rgb(218, 208, 254)',
  '350': 'rgb(212, 200, 255)',
  '400': 'rgb(206, 191, 255)',
  '450': 'rgb(186, 166, 252)',
  '500': 'rgb(166, 141, 249)',
  '550': 'rgb(147, 114, 245)',
  '600': 'rgb(128, 85, 241)',
  '650': 'rgb(114, 67, 207)',
  '700': 'rgb(100, 50, 174)',
  '750': 'rgb(84, 33, 142)',
  '800': 'rgb(68, 17, 112)',
  '850': 'rgb(51, 8, 86)',
  '900': 'rgb(35, 2, 62)',
  '950': 'rgb(19, 0, 39)',
}
export const nswFuchsia = {
  '50': 'rgb(255, 246, 253)',
  '100': 'rgb(255, 238, 249)',
  '150': 'rgb(254, 230, 246)',
  '200': 'rgb(253, 222, 242)',
  '250': 'rgb(251, 212, 239)',
  '300': 'rgb(249, 201, 235)',
  '350': 'rgb(247, 191, 233)',
  '400': 'rgb(244, 181, 230)',
  '450': 'rgb(239, 150, 218)',
  '500': 'rgb(233, 117, 204)',
  '550': 'rgb(225, 80, 190)',
  '600': 'rgb(217, 18, 174)',
  '650': 'rgb(187, 12, 148)',
  '700': 'rgb(157, 6, 123)',
  '750': 'rgb(129, 2, 100)',
  '800': 'rgb(101, 0, 77)',
  '850': 'rgb(77, 0, 58)',
  '900': 'rgb(55, 0, 40)',
  '950': 'rgb(34, 0, 23)',
}
export const nswRed = {
  '50': 'rgb(255, 248, 249)',
  '100': 'rgb(255, 242, 244)',
  '150': 'rgb(255, 236, 239)',
  '200': 'rgb(255, 230, 234)',
  '250': 'rgb(255, 219, 224)',
  '300': 'rgb(255, 207, 214)',
  '350': 'rgb(255, 196, 204)',
  '400': 'rgb(255, 184, 193)',
  '450': 'rgb(248, 151, 162)',
  '500': 'rgb(239, 117, 129)',
  '550': 'rgb(228, 79, 95)',
  '600': 'rgb(215, 21, 58)',
  '650': 'rgb(185, 14, 50)',
  '700': 'rgb(155, 7, 42)',
  '750': 'rgb(126, 3, 34)',
  '800': 'rgb(99, 0, 25)',
  '850': 'rgb(76, 0, 16)',
  '900': 'rgb(54, 0, 8)',
  '950': 'rgb(33, 0, 3)',
}
export const nswOrange = {
  '50': 'rgb(255, 250, 246)',
  '100': 'rgb(255, 246, 238)',
  '150': 'rgb(254, 241, 231)',
  '200': 'rgb(253, 237, 223)',
  '250': 'rgb(254, 229, 206)',
  '300': 'rgb(255, 221, 189)',
  '350': 'rgb(255, 214, 171)',
  '400': 'rgb(255, 206, 153)',
  '450': 'rgb(253, 182, 120)',
  '500': 'rgb(251, 157, 88)',
  '550': 'rgb(247, 129, 57)',
  '600': 'rgb(243, 99, 27)',
  '650': 'rgb(219, 81, 21)',
  '700': 'rgb(195, 63, 14)',
  '750': 'rgb(171, 46, 6)',
  '800': 'rgb(148, 27, 0)',
  '850': 'rgb(115, 15, 0)',
  '900': 'rgb(83, 4, 0)',
  '950': 'rgb(53, 0, 0)',
}
export const nswYellow = {
  '50': 'rgb(255, 252, 240)',
  '100': 'rgb(255, 250, 229)',
  '150': 'rgb(255, 247, 218)',
  '200': 'rgb(255, 244, 207)',
  '250': 'rgb(255, 241, 194)',
  '300': 'rgb(254, 238, 181)',
  '350': 'rgb(254, 234, 168)',
  '400': 'rgb(253, 231, 154)',
  '450': 'rgb(251, 218, 128)',
  '500': 'rgb(250, 205, 99)',
  '550': 'rgb(250, 190, 66)',
  '600': 'rgb(250, 175, 5)',
  '650': 'rgb(212, 148, 3)',
  '700': 'rgb(175, 122, 1)',
  '750': 'rgb(139, 96, 0)',
  '800': 'rgb(105, 72, 0)',
  '850': 'rgb(80, 53, 0)',
  '900': 'rgb(57, 36, 0)',
  '950': 'rgb(34, 19, 0)',
}
export const nswBrown = {
  '50': 'rgb(251, 248, 244)',
  '100': 'rgb(246, 241, 234)',
  '150': 'rgb(242, 234, 225)',
  '200': 'rgb(237, 227, 215)',
  '250': 'rgb(236, 222, 206)',
  '300': 'rgb(234, 218, 198)',
  '350': 'rgb(233, 213, 189)',
  '400': 'rgb(232, 208, 181)',
  '450': 'rgb(219, 191, 159)',
  '500': 'rgb(207, 174, 137)',
  '550': 'rgb(194, 157, 115)',
  '600': 'rgb(182, 141, 93)',
  '650': 'rgb(156, 118, 75)',
  '700': 'rgb(130, 96, 58)',
  '750': 'rgb(106, 75, 41)',
  '800': 'rgb(82, 55, 25)',
  '850': 'rgb(62, 40, 15)',
  '900': 'rgb(43, 26, 7)',
  '950': 'rgb(25, 13, 2)',
}
export const nswAboriginalGrey = {
  '50': 'rgb(249, 248, 247)',
  '100': 'rgb(242, 241, 239)',
  '150': 'rgb(235, 234, 232)',
  '200': 'rgb(229, 227, 224)',
  '250': 'rgb(223, 220, 216)',
  '300': 'rgb(216, 212, 209)',
  '350': 'rgb(210, 205, 201)',
  '400': 'rgb(204, 198, 194)',
  '450': 'rgb(173, 168, 165)',
  '500': 'rgb(142, 139, 138)',
  '550': 'rgb(113, 112, 111)',
  '600': 'rgb(85, 85, 85)',
  '650': 'rgb(73, 73, 73)',
  '700': 'rgb(61, 61, 61)',
  '750': 'rgb(50, 50, 50)',
  '800': 'rgb(39, 39, 39)',
  '850': 'rgb(28, 28, 28)',
  '900': 'rgb(17, 17, 17)',
  '950': 'rgb(7, 7, 7)',
}
export const nswAboriginalRed = {
  '50': 'rgb(255, 245, 245)',
  '100': 'rgb(255, 235, 235)',
  '150': 'rgb(254, 226, 226)',
  '200': 'rgb(253, 217, 217)',
  '250': 'rgb(253, 208, 208)',
  '300': 'rgb(252, 199, 198)',
  '350': 'rgb(252, 189, 189)',
  '400': 'rgb(251, 180, 179)',
  '450': 'rgb(247, 150, 147)',
  '500': 'rgb(242, 119, 113)',
  '550': 'rgb(234, 85, 76)',
  '600': 'rgb(225, 38, 28)',
  '650': 'rgb(205, 31, 23)',
  '700': 'rgb(186, 24, 17)',
  '750': 'rgb(167, 17, 11)',
  '800': 'rgb(149, 9, 6)',
  '850': 'rgb(116, 0, 1)',
  '900': 'rgb(84, 0, 0)',
  '950': 'rgb(54, 0, 0)',
}
export const nswAboriginalOrange = {
  '50': 'rgb(255, 244, 236)',
  '100': 'rgb(254, 233, 221)',
  '150': 'rgb(252, 223, 205)',
  '200': 'rgb(249, 212, 190)',
  '250': 'rgb(248, 202, 174)',
  '300': 'rgb(247, 191, 158)',
  '350': 'rgb(246, 181, 142)',
  '400': 'rgb(244, 170, 125)',
  '450': 'rgb(243, 154, 102)',
  '500': 'rgb(242, 137, 79)',
  '550': 'rgb(240, 119, 54)',
  '600': 'rgb(238, 99, 20)',
  '650': 'rgb(212, 83, 16)',
  '700': 'rgb(186, 68, 10)',
  '750': 'rgb(161, 53, 5)',
  '800': 'rgb(136, 38, 0)',
  '850': 'rgb(105, 25, 0)',
  '900': 'rgb(76, 13, 0)',
  '950': 'rgb(48, 3, 0)',
}
export const nswAboriginalBrown = {
  '50': 'rgb(252, 241, 233)',
  '100': 'rgb(246, 227, 215)',
  '150': 'rgb(239, 213, 196)',
  '200': 'rgb(233, 200, 178)',
  '250': 'rgb(228, 186, 159)',
  '300': 'rgb(222, 173, 140)',
  '350': 'rgb(217, 159, 120)',
  '400': 'rgb(211, 145, 101)',
  '450': 'rgb(198, 129, 88)',
  '500': 'rgb(185, 114, 75)',
  '550': 'rgb(171, 98, 62)',
  '600': 'rgb(158, 83, 50)',
  '650': 'rgb(139, 70, 39)',
  '700': 'rgb(121, 57, 28)',
  '750': 'rgb(103, 45, 16)',
  '800': 'rgb(85, 33, 5)',
  '850': 'rgb(65, 22, 2)',
  '900': 'rgb(45, 12, 0)',
  '950': 'rgb(27, 4, 0)',
}
export const nswAboriginalYellow = {
  '50': 'rgb(255, 252, 238)',
  '100': 'rgb(255, 248, 224)',
  '150': 'rgb(255, 245, 211)',
  '200': 'rgb(255, 241, 197)',
  '250': 'rgb(255, 238, 183)',
  '300': 'rgb(255, 235, 169)',
  '350': 'rgb(254, 231, 155)',
  '400': 'rgb(254, 228, 140)',
  '450': 'rgb(254, 214, 117)',
  '500': 'rgb(254, 200, 93)',
  '550': 'rgb(254, 185, 68)',
  '600': 'rgb(254, 169, 39)',
  '650': 'rgb(223, 150, 28)',
  '700': 'rgb(193, 131, 18)',
  '750': 'rgb(165, 112, 7)',
  '800': 'rgb(137, 94, 0)',
  '850': 'rgb(105, 71, 0)',
  '900': 'rgb(76, 48, 0)',
  '950': 'rgb(47, 28, 0)',
}
export const nswAboriginalGreen = {
  '50': 'rgb(245, 249, 242)',
  '100': 'rgb(236, 243, 231)',
  '150': 'rgb(227, 236, 220)',
  '200': 'rgb(218, 230, 209)',
  '250': 'rgb(209, 224, 198)',
  '300': 'rgb(199, 217, 186)',
  '350': 'rgb(190, 211, 175)',
  '400': 'rgb(181, 205, 164)',
  '450': 'rgb(165, 194, 142)',
  '500': 'rgb(149, 183, 119)',
  '550': 'rgb(134, 172, 96)',
  '600': 'rgb(120, 161, 70)',
  '650': 'rgb(95, 143, 68)',
  '700': 'rgb(73, 125, 64)',
  '750': 'rgb(52, 106, 59)',
  '800': 'rgb(33, 88, 52)',
  '850': 'rgb(21, 66, 37)',
  '900': 'rgb(10, 46, 23)',
  '950': 'rgb(2, 27, 10)',
}
export const nswAboriginalBlue = {
  '50': 'rgb(238, 248, 250)',
  '100': 'rgb(223, 241, 244)',
  '150': 'rgb(208, 233, 238)',
  '200': 'rgb(193, 226, 232)',
  '250': 'rgb(178, 219, 226)',
  '300': 'rgb(163, 212, 220)',
  '350': 'rgb(148, 204, 215)',
  '400': 'rgb(132, 197, 209)',
  '450': 'rgb(103, 174, 192)',
  '500': 'rgb(74, 150, 176)',
  '550': 'rgb(46, 127, 161)',
  '600': 'rgb(13, 103, 145)',
  '650': 'rgb(9, 93, 132)',
  '700': 'rgb(5, 83, 119)',
  '750': 'rgb(2, 73, 106)',
  '800': 'rgb(0, 64, 94)',
  '850': 'rgb(0, 47, 72)',
  '900': 'rgb(0, 32, 51)',
  '950': 'rgb(0, 17, 31)',
}
export const nswAboriginalPurple = {
  '50': 'rgb(250, 241, 248)',
  '100': 'rgb(242, 229, 240)',
  '150': 'rgb(235, 216, 232)',
  '200': 'rgb(228, 204, 224)',
  '250': 'rgb(221, 191, 216)',
  '300': 'rgb(215, 179, 209)',
  '350': 'rgb(208, 166, 201)',
  '400': 'rgb(201, 154, 194)',
  '450': 'rgb(189, 139, 182)',
  '500': 'rgb(177, 124, 170)',
  '550': 'rgb(166, 109, 159)',
  '600': 'rgb(154, 94, 147)',
  '650': 'rgb(132, 79, 126)',
  '700': 'rgb(111, 65, 105)',
  '750': 'rgb(91, 51, 85)',
  '800': 'rgb(71, 38, 66)',
  '850': 'rgb(53, 26, 49)',
  '900': 'rgb(36, 16, 33)',
  '950': 'rgb(21, 6, 18)',
}
export const success = {
  '50': 'rgb(239, 249, 237)',
  '100': 'rgb(224, 243, 222)',
  '150': 'rgb(210, 236, 207)',
  '200': 'rgb(196, 229, 192)',
  '250': 'rgb(170, 214, 165)',
  '300': 'rgb(143, 199, 138)',
  '350': 'rgb(116, 183, 111)',
  '400': 'rgb(88, 168, 84)',
  '450': 'rgb(73, 161, 70)',
  '500': 'rgb(57, 153, 54)',
  '550': 'rgb(37, 146, 36)',
  '600': 'rgb(0, 138, 7)',
  '650': 'rgb(0, 114, 4)',
  '700': 'rgb(0, 90, 2)',
  '750': 'rgb(0, 68, 1)',
  '800': 'rgb(0, 47, 0)',
  '850': 'rgb(0, 34, 0)',
  '900': 'rgb(0, 22, 0)',
  '950': 'rgb(0, 11, 0)',
}
export const warning = {
  '50': 'rgb(255, 243, 237)',
  '100': 'rgb(255, 232, 222)',
  '150': 'rgb(255, 221, 207)',
  '200': 'rgb(253, 210, 192)',
  '250': 'rgb(246, 189, 165)',
  '300': 'rgb(238, 168, 138)',
  '350': 'rgb(230, 147, 111)',
  '400': 'rgb(221, 125, 83)',
  '450': 'rgb(216, 114, 68)',
  '500': 'rgb(211, 103, 52)',
  '550': 'rgb(206, 92, 33)',
  '600': 'rgb(201, 80, 0)',
  '650': 'rgb(168, 63, 3)',
  '700': 'rgb(136, 47, 3)',
  '750': 'rgb(105, 32, 1)',
  '800': 'rgb(75, 18, 0)',
  '850': 'rgb(57, 10, 0)',
  '900': 'rgb(39, 4, 0)',
  '950': 'rgb(23, 1, 0)',
}
export const danger = {
  '50': 'rgb(255, 240, 239)',
  '100': 'rgb(255, 226, 225)',
  '150': 'rgb(255, 212, 212)',
  '200': 'rgb(253, 198, 198)',
  '250': 'rgb(244, 172, 173)',
  '300': 'rgb(234, 146, 148)',
  '350': 'rgb(223, 120, 124)',
  '400': 'rgb(211, 93, 101)',
  '450': 'rgb(205, 78, 89)',
  '500': 'rgb(198, 63, 78)',
  '550': 'rgb(191, 44, 66)',
  '600': 'rgb(184, 18, 55)',
  '650': 'rgb(153, 11, 42)',
  '700': 'rgb(124, 6, 31)',
  '750': 'rgb(95, 2, 20)',
  '800': 'rgb(68, 0, 10)',
  '850': 'rgb(51, 0, 5)',
  '900': 'rgb(35, 0, 2)',
  '950': 'rgb(20, 0, 1)',
}
export const info = {
  '50': 'rgb(233, 238, 247)',
  '100': 'rgb(212, 221, 235)',
  '150': 'rgb(192, 204, 224)',
  '200': 'rgb(172, 187, 213)',
  '250': 'rgb(150, 169, 204)',
  '300': 'rgb(128, 152, 194)',
  '350': 'rgb(107, 134, 184)',
  '400': 'rgb(87, 117, 174)',
  '450': 'rgb(77, 108, 169)',
  '500': 'rgb(66, 100, 164)',
  '550': 'rgb(56, 91, 158)',
  '600': 'rgb(46, 82, 153)',
  '650': 'rgb(35, 66, 127)',
  '700': 'rgb(25, 51, 102)',
  '750': 'rgb(16, 37, 79)',
  '800': 'rgb(7, 23, 56)',
  '850': 'rgb(4, 15, 42)',
  '900': 'rgb(2, 7, 28)',
  '950': 'rgb(0, 3, 15)',
}
export const white = 'rgb(255, 255, 255)'
export const black = 'rgb(0, 0, 0)'
